import styled from '@emotion/styled';
import { Box, Button, Theme } from '@mui/material';

export const StyledLine = styled(Box)({
  width: '100%',
  height: '1px',
  background: '#eee',
  marginBottom: '39px',
});

export const StyledFooterWrapper = styled(Box)<{ theme?: Theme }>(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-around',
  [theme?.breakpoints.down('sm')]: {
    flexWrap: 'wrap',
  },
}));

export const StyledCancelButton = styled(Button)<{ theme?: Theme }>(({ theme }) => ({
  fontSize: '14px',
  fontWeight: 'bold',
  width: theme?.spacing(20),
  border: `1px solid ${theme?.palette.grey[200]}`,
  height: theme?.spacing(5),
  borderRadius: theme?.spacing(0.5),
}));

export const StyledHiddenButton = styled(Button)<{ theme?: Theme }>(({ theme }) => ({
  fontSize: '14px',
  fontWeight: 'bold',
  width: theme?.spacing(20),
  border: `1px solid ${theme?.palette.grey[200]}`,
  height: theme?.spacing(5),
  borderRadius: theme?.spacing(0.5),
  visibility: 'hidden',
  [theme?.breakpoints.down('sm')]: {
    display: 'none',
  },
}));

export const StyledLoadingButton = styled(Button)<{ theme?: Theme }>(({ theme }) => ({
  fontSize: '14px',
  fontWeight: 'bold',
  minWidth: theme?.spacing(20),
  border: `1px solid ${theme?.palette.grey[200]}`,
  height: theme?.spacing(5),
  borderRadius: theme?.spacing(0.5),
  padding: theme?.spacing(0, 1),
  boxShadow: 'none',
  '&:is(:hover, :active)': {
    boxShadow: 'none',
  },
}));

export const StyledLicenseStyle = styled(Box)<{ theme?: Theme }>(({ theme }) => ({
  color: '#888',
  fontSize: '14px',
  padding: theme?.spacing(0, 4),
  alignSelf: 'center',
  textAlign: 'center',
  [theme?.breakpoints.down('sm')]: {
    order: -1,
    marginBottom: theme?.spacing(3),
    padding: theme?.spacing(0, 'auto'),
  },
}));

export const StyledConditions = styled('span')({
  textDecoration: 'underline',
  textDecorationColor: '#888',
  color: '#888',
  marginInlineStart: '5px',
});

export const StyledMobileWidthSubmitButton = styled(Button)<{ theme?: Theme }>(({ theme }) => ({
  fontSize: '14px',
  fontWeight: 'bold',
  minWidth: theme?.spacing(20),
  border: `1px solid ${theme?.palette.grey[200]}`,
  height: theme?.spacing(5),
  borderRadius: theme?.spacing(0.5),
  padding: theme?.spacing(0, 1),
  marginTop: '20px',
  width: '180px',
}));
